<script>
    import { onMount } from "svelte";

    import Select from "svelte-select/Select.svelte";

    import { apiMethods } from "../../Services/index.svelte";
    import {
        getFormatDate,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";
    import {
        DateInput,
        NotificationModal,
    } from "../../Components/Common/index.svelte";

    export let isCreateInvoiceModalOpen = false;
    export let closeCreateInvoiceModal = () => {};
    export let handleCreateInvoice = () => {};

    let isLoadingAccounts = false,
        isCreatingInvoice = false,
        returnedAccountsArr = [],
        selectedAccount,
        invoiceDetails = {};

    $: periodsObj = handleDateSelect(invoiceDetails.endDate);

    $: isDisabledCreateBtn = !invoiceDetails.doctorId || !periodsObj.isValid;

    onMount(() => {
        loadAccounts();
    });

    const loadAccounts = async () => {
        isLoadingAccounts = true;

        await apiMethods.getMethod.getAccount(0, 999999).then((res) => {
            if (res.results && res.results.length)
                returnedAccountsArr = [...res.results];
        });

        isLoadingAccounts = false;
    };

    const createInvoice = async () => {
        isCreatingInvoice = true;

        const obj = {
            doctorId: invoiceDetails.doctorId,
            createdDate: invoiceDetails.endDate,
        };

        await apiMethods.postMethod
            .createAccountInvoice(obj)
            .then((res) => handleCreateInvoice(res))
            .catch((err) => showException(err));

        closeModal();

        isCreatingInvoice = false;
    };

    const clearSelectedAccount = () => {
        selectedAccount = null;
        if (invoiceDetails.doctorId) delete invoiceDetails.doctorId;
    };

    const handleSelectAccount = (e) => {
        invoiceDetails.doctorId = e.detail.id;
    };

    const handleDateSelect = (date) => {
        const res = {
            isShow: false,
            isValid: false,
            periodText: "",
        };

        if (!date) return res;

        const dateArr = date.split("-");

        if (!dateArr.length || dateArr.length != 3) return res;

        if (dateArr[0] >= 2050 || dateArr[0] <= 1990)
            return {
                ...res,
                isShow: true,
                periodText: "Invalid date, please try a different date",
            };

        const dateFortnightBefore = new Date(new Date(date) - 12096e5)
            .toISOString()
            .split("T")[0];

        res.isShow = true;
        res.isValid = true;
        res.periodText = `${getFormatDate(
            dateFortnightBefore,
            "/",
        )} - ${getFormatDate(invoiceDetails.endDate, "/")}`;

        return res;
    };

    const closeModal = () => {
        closeCreateInvoiceModal();
        clearSelectedAccount();
        invoiceDetails = {};
    };
</script>

<NotificationModal
    title="Create Invoice"
    isModalOpen={isCreateInvoiceModalOpen}
    showConfirmBtn={false}
    cancelText="Close"
    isConfirming={isCreatingInvoice}
    {closeModal}
    closeModalFunction={closeModal}
    btnOptions={[
        {
            text: isCreatingInvoice ? "Creating" : "Create",
            loading: isCreatingInvoice || isDisabledCreateBtn,
            function: () => createInvoice(),
        },
    ]}
>
    <div class="flex flex-1 flex-col gap-y-4">
        <div class="flex flex-1 gap-x-4">
            <p class="w-36">Select Account:</p>

            <div class="autoFillSelector flex-1">
                <Select
                    class="flex flex-1 rounded-full relative"
                    bind:value={selectedAccount}
                    items={returnedAccountsArr}
                    itemId="id"
                    label="fullName"
                    on:clear={clearSelectedAccount}
                    on:select={handleSelectAccount}
                    disabled={isLoadingAccounts || isCreatingInvoice}
                    noOptionsMessage="No Doctors Found"
                    --border="none"
                    --border-focused="none"
                    --border-hover="none"
                />
            </div>
        </div>

        <div class="flex flex-1 gap-x-4">
            <p class="w-36">Period End:</p>

            <div class="flex flex-1">
                <!-- <input
                    type="date"
                    class="w-full border-b-2 border-[#818e9b] outline-none pl-3"
                    bind:value={invoiceDetails.endDate}
                    disabled={isCreatingInvoice}
                /> -->
                <DateInput
                    bind:value={invoiceDetails.endDate}
                    isDisable={isCreatingInvoice}
                    wrapperClass="borderB h-[24px]"
                />
            </div>
        </div>

        {#if periodsObj.isShow}
            <div class="flex flex-1 gap-x-4">
                <p class="w-36">Periods:</p>

                <div class="flex flex-1">
                    <p
                        class={`pl-3 ${
                            periodsObj.isValid ? "text-secondary" : "text-error"
                        }`}
                    >
                        {periodsObj.periodText}
                    </p>
                </div>
            </div>
        {/if}
    </div>
</NotificationModal>

<style>
    .autoFillSelector {
        --border: none;
        --height: 24px;
        border-bottom: 2px solid #818e9b;
    }
</style>
